"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var initialState = null;

var CustomerCurrencyCode = function CustomerCurrencyCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.CUSTOMER_CURRENCY_CODE_RECEIVED:
      return payload;

    default:
      return state;
  }
};

var _default = CustomerCurrencyCode;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/CustomerCurrencyCode.js
// module id = 521
// module chunks = 5 6